import { Component, OnInit } from '@angular/core';
import { ConfigService, DocumentService, GtmDataLayer } from 'src/app/main';
import { GtmAnnouncerService } from '../../../main/services/gtm-announcer.service';

const GOOGLE_TAG_MANAGER = `
(function(w, d, s, l, i) {
  w[l] = w[l] || []; w[l].push({
    'gtm.start':
      new Date().getTime(), event: 'gtm.js'
  }); var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
}) (window, document, 'script', 'dataLayer', 'GTM-PMCP85K');`;

@Component({
  selector: 'app-cookie-consent-modal',
  templateUrl: './cookie-consent-modal.component.html',
  styleUrls: ['./cookie-consent-modal.component.css']
})
export class CookieConsentModalComponent implements OnInit {
  showModal: boolean = false;
  cookiesAccepted: boolean = false;

  constructor(
    private docHelperService: DocumentService,
    private configService: ConfigService,
    private gtmAnnouncerService: GtmAnnouncerService,

  ) { }
  ngOnInit() {
    this.checkCookie();
  }

  acceptCookies() {
    this.setCookie("cookie_consent", "true", 365);
    // this.saveSettings();
    this.showModal = false;

    this.gtmAnnouncerService.announceEvent({cookieAccepted: this.getCookie('cookie_consent') })
  }

  saveSettings() {
    if (this.configService.config.googleTagManagerActive) {
      this.docHelperService.addContentScript(GOOGLE_TAG_MANAGER);
    }
  }

  rejectCookies() {
    this.showModal = false;
    this.setCookie("cookie_consent", "false", 365);
    this.gtmAnnouncerService.announceEvent({cookieAccepted: this.getCookie('cookie_consent') })
  }

  getCookie(cname: string) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

  checkCookie() {
    var consentCookie = this.getCookie("cookie_consent");
    if (consentCookie !== "") {
    } else {
      this.showModal = true
    }
  }


}
